var map = {
	"./data": "1725",
	"./data.json": "1725",
	"./icon-ellipsis.svg": "b252",
	"./icon-exercise.svg": "8143",
	"./icon-play.svg": "52eb",
	"./icon-self-care.svg": "610b",
	"./icon-social.svg": "9539",
	"./icon-study.svg": "5bb1",
	"./icon-work.svg": "9df8",
	"./image-jeremy.png": "6a49",
	"./styles.css": "a347"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";